export default {
  LEARN: "सीखिए",
};
